import { usePermissionsContext } from "../context/PermissionsContext";

/**
 * @param {string} actionKey
 * @returns {{ previewLevel: number, hidden: boolean, disabled: boolean }}
 */
export function usePermission(actionKey) {
  const { superAdmin, permissions } = usePermissionsContext();

  // 🔐 Log de vérification des valeurs reçues
  // console.groupCollapsed(`🔍 [usePermission] actionKey: "${actionKey}"`);
  // console.log("🔸 superAdmin :", superAdmin);
  // console.log("🔸 permissions:", permissions);
  // console.groupEnd();

  // 🔓 Accès total si superAdmin
  if (superAdmin) {
    // console.groupCollapsed(`🔐 usePermission("${actionKey}") [SUPERADMIN OVERRIDE]`);
    // console.log("🎖 Accès total accordé car superAdmin = true");
    // console.groupEnd();
    return {
      previewLevel: 2,
      hidden: false,
      disabled: false,
    };
  }

  // 🔎 Lecture des permissions
  const rawLevel = permissions?.[actionKey];
  const previewLevel = rawLevel != null ? rawLevel : 0;

  const hidden = previewLevel === 0;
  const disabled = previewLevel === 1;

  // console.groupCollapsed(`🔐 usePermission("${actionKey}")`);
  // console.log("🔑 actionKey    :", actionKey);
  // console.log("→ rawLevel      :", rawLevel);
  // console.log("→ previewLevel  :", previewLevel);
  // console.log("→ hidden        :", hidden);
  // console.log("→ disabled      :", disabled);
  // console.groupEnd();

  return {
    previewLevel,
    hidden,
    disabled,
  };
}
